/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

const searchDataMenuListEpic = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TRANSPORTATION.SEARCH),
      mergeMap((action) => {
         const api = async () => {
            let params = ""
            if (action.payload.keyword !== null && action.payload.keyword.trim() !== "")
               params = `?keyword=${action.payload.keyword}&page=${action.payload.page}`
            else params = `?page=${action.payload.page}`
            const transportations = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TRANSPORTATION.GET_ALL + params)
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.GET_ALL_TRANSPORTATION_OF_ACCOUNT, transportations.data))
            if (transportations.data.data.length)
               arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TRANSPORTATION.SET_CURRENT_TRANSPORTATION, transportations.data.data[0]))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

/* Menu Danh mục */
// Danh mục công việc
const getAllTodoList = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_LIST.GET_TODO_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}
            // Lấy danh sách việc
            const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TODO_LIST.GET_ALL, action.payload)
            data = { danhSachDanhMuc: danhSachDanhMuc.data }
            if (danhSachDanhMuc.data.data.length > 0) {
               // Lấy chi tiết việc đầu tiên trong danh sách
               const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TODO_LIST.GET_BY_ID, { id: danhSachDanhMuc.data.data[0].id })
               data.chiTietDanhMuc = chiTietDanhMuc.data.data
            } else {
               data.chiTietDanhMuc = {}
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API lấy chi tiết danh mục công việc đang select
const getTodoDetail = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_LIST.GET_TODO_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TODO_LIST.GET_BY_ID, action.payload)
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data }
            const arrayAction = []

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API thêm mới 1 công việc
const addTodo = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_LIST.POST_TODO_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TODO_LIST.POST, action.payload)

            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TODO_LIST.GET_TODO_LIST, { keyword: "", page: 1 }))
            addTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API cập nhật công việc
const updateTodo = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_LIST.PUT_TODO_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.TODO_LIST.PUT, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TODO_LIST.GET_TODO_LIST, { keyword: "", page: 1 }))
            updateTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API xóa công việc đang chọn
const deleteTodo = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.TODO_LIST.DELETE_TODO_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TODO_LIST.DELETE, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TODO_LIST.GET_TODO_LIST, { keyword: "", page: 1 }))
            deleteTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// DANH MỤC BẢO DƯỠNG
const LayDanhMucBaoDuong = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.GET_DANH_MUC_BAO_DUONG_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}
            // Lấy danh sách việc
            const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_MUC_BAO_DUONG.GET_ALL, action.payload)
            data = { danhSachDanhMuc: danhSachDanhMuc.data }

            // Lấy danh sách tỉnh thành
            const danhSachTinhThanh = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TINH_THANH.GET_ALL, action.payload)

            data = {
               danhSachDanhMuc: danhSachDanhMuc.data,
               danhSachTinhThanh: danhSachTinhThanh.data
            }

            if (danhSachDanhMuc.data.data.length > 0) {
               // Lấy chi tiết việc đầu tiên trong danh sách
               const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_MUC_BAO_DUONG.GET_BY_ID, { id: danhSachDanhMuc.data.data[0].id })
               data.chiTietDanhMuc = chiTietDanhMuc.data.data
            } else {
               data.chiTietDanhMuc = {}
            }

            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API lấy chi tiết bảo dưỡng đang select
const LayChiTietDanhMucBaoDuong = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.GET_DANH_MUC_BAO_DUONG_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_MUC_BAO_DUONG.GET_BY_ID, action.payload)
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data }

            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API thêm mới bảo dưỡng
const AddBaoDuong = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.POST_DANH_MUC_BAO_DUONG_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_MUC_BAO_DUONG.POST, action.payload)

            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.GET_DANH_MUC_BAO_DUONG_LIST, { keyword: "", page: 1 }))
            addTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API cập nhật bảo dưỡng
const UpdateBaoDuong = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.PUT_DANH_MUC_BAO_DUONG_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_MUC_BAO_DUONG.PUT, action.payload)
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.GET_DANH_MUC_BAO_DUONG_LIST, { keyword: "", page: 1 }))
            updateTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API xóa bảo dưỡng
const DeleteBaoDuong = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.DELETE_DANH_MUC_BAO_DUONG_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_MUC_BAO_DUONG.DELETE, action.payload)

            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_MUC_BAO_DUONG.GET_DANH_MUC_BAO_DUONG_LIST, { keyword: "", page: 1 }))
            deleteTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// DANH SÁCH TRUNG TÂM ĐĂNG KIỂM
//  Lấy danh sách trung tâm đăng kiểm
const LayDanhSachTrungTamDangKiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            // Lấy danh sách việc
            const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_ALL, { ...action.payload, type: 1 })

            // Lấy danh sách tỉnh thành
            const danhSachTinhThanh = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TINH_THANH.GET_ALL, action.payload)

            data = {
               danhSachDanhMuc: danhSachDanhMuc.data,
               danhSachTinhThanh: danhSachTinhThanh.data
            }

            if (danhSachDanhMuc.data.data.length > 0) {
               // Lấy chi tiết việc đầu tiên trong danh sách
               const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_BY_ID, {
                  id: danhSachDanhMuc.data.data[0].id,
                  type: 1
               })
               data.chiTietDanhMuc = chiTietDanhMuc.data.data
            } else {
               data.chiTietDanhMuc = {}
            }

            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API lấy chi tiết của trung tâm đăng kiểm đang được focus
const LayChiTietDanhSachTrungTamDangKiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            // Lấy danh sách việc
            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_BY_ID, { ...action.payload, type: 1 })
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API thêm mới trung tâm đăng kiểm
const AddTrungTamDangKiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.POST_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_TRUNG_TAM_DANG_KIEM.POST, { ...action.payload, type: 1 })
            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            addTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API cập nhật trung tâm đăng kiểm
const UpdateTrungTamDangKiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.PUT_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_TRUNG_TAM_DANG_KIEM.PUT, { ...action.payload, type: 1 })
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            updateTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API xáo trung tâm đăng kiểm
const DeleteTrungTamDangKiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.DELETE_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TRUNG_TAM_DANG_KIEM.DELETE, { ...action.payload, type: 1 })
            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_TRUNG_TAM_DANG_KIEM.GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            deleteTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy danh sách nhà cung cấp bảo hiểm
const LayDanhSachNhaCungCapBaoHiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            // Lấy danh sách việc
            const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_ALL, { ...action.payload, type: 4 })

            // Lấy danh sách tỉnh thành
            const danhSachTinhThanh = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TINH_THANH.GET_ALL, action.payload)

            data = {
               danhSachDanhMuc: danhSachDanhMuc.data,
               danhSachTinhThanh: danhSachTinhThanh.data
            }

            if (danhSachDanhMuc.data.data.length > 0) {
               // Lấy chi tiết việc đầu tiên trong danh sách
               const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_BY_ID, {
                  id: danhSachDanhMuc.data.data[0].id,
                  type: 4
               })
               data.chiTietDanhMuc = chiTietDanhMuc.data.data
            } else {
               data.chiTietDanhMuc = {}
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API lấy chi tiết bảo hiểm đang focus
const LayChiTietBaoHiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_BY_ID, { ...action.payload, type: 4 }) //action.payload  { ...action.payload, type: 4 }
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API thêm mới bảo hiểm
const AddBaoHiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.POST_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.POST, { ...action.payload, type: 4 })
            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            addTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API cập nhật bảo hiểm
const UpdateBaoHiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.PUT_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.PUT, { ...action.payload, type: 4 })
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            updateTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API xóa bảo hiểm
const DeleteBaoHiem = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.DELETE_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.DELETE, { ...action.payload, type: 4 })

            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_BAO_HIEM.GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            deleteTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// DANH SÁCH NHÀ CUNG CẤP PHÙ HIỆU
// API lấy danh sách nhà cung cấp phù hiệu, đổ vào list
const LayDanhSachNhaCungCapPhuHieu = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            // Lấy danh sách việc
            const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_ALL, {
               ...action.payload,
               type: 2
            })

            // Lấy danh sách tỉnh thành
            const danhSachTinhThanh = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TINH_THANH.GET_ALL, action.payload)

            data = { danhSachDanhMuc: danhSachDanhMuc.data, danhSachTinhThanh: danhSachTinhThanh.data }

            if (danhSachDanhMuc.data.data.length > 0) {
               // Lấy chi tiết việc đầu tiên trong danh sách
               const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_BY_ID, {
                  id: danhSachDanhMuc.data.data[0].id,
                  type: 2
               })
               data.chiTietDanhMuc = chiTietDanhMuc.data.data
            } else {
               data.chiTietDanhMuc = {}
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API lấy chi tiết phù hiệu đang select
const LayChiTietPhuHieu = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_BY_ID, {
               ...action.payload,
               type: 2
            })
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API thêm mới phù hiệu
const AddPhuHieu = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.POST_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.POST, { ...action.payload, type: 2 })
            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            addTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API cập nhật phù hiệu
const UpdatePhuHieu = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.PUT_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.PUT, { ...action.payload, type: 2 })
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            updateTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API xóa phù hiệu
const DeletePhuHieu = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.DELETE_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.DELETE, { ...action.payload, type: 2 })
            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_PHU_HIEU.GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            deleteTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// DANH SÁCH NHÀ CUNG CẤP ĐĂNG KÝ XE
// API lấy danh sách nhà cung cấp đăng ký xe
const LayDanhSachNhaCungCapDangKyXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            // Lấy danh sách việc
            const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_ALL, { ...action.payload, type: 3 })

            // Lấy danh sách tỉnh thành
            const danhSachTinhThanh = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_TINH_THANH.GET_ALL, action.payload)

            data = {
               danhSachDanhMuc: danhSachDanhMuc.data,
               danhSachTinhThanh: danhSachTinhThanh.data
            }

            if (danhSachDanhMuc.data.data.length > 0) {
               // Lấy chi tiết việc đầu tiên trong danh sách
               const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_BY_ID, {
                  id: danhSachDanhMuc.data.data[0].id,
                  type: 3
               })
               data.chiTietDanhMuc = chiTietDanhMuc.data.data
            } else {
               data.chiTietDanhMuc = {}
            }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API lấy chi tiết đăng ký xe đang select
const LayChiTietDangKyXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_BY_ID, { ...action.payload, type: 3 })
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data }
            const arrayAction = []

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API thêm mới đăng ký xe
const AddDangKyXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.POST_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const addTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.POST, { ...action.payload, type: 3 })
            // Reload lại state để cập nhật đăng kiểm vừa thêm mới
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            addTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, addTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, addTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API cập nhật đăng ký xe
const UpdateDangKyXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.PUT_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.PUT, { ...action.payload, type: 3 })
            // Reload lại state để cập nhật đăng kiểm vừa cập nhật
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            updateTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// API xóa đăng ký xe
const DeleteDangKyXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.DELETE_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.DELETE, { ...action.payload, type: 3 })
            // Reload lại state để cập nhật đăng kiểm vừa xoá
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST, {
                  keyword: "",
                  page: 1
               })
            )
            deleteTodoList.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// DANH SÁCH TÀI XẾ
// API lấy danh sách tài xế
// const LayDanhSachTaiXe = (action$, state$) =>
//    action$.pipe(
//       ofType(CONSTANTS.ACTION.DRIVERS_TRANSPORTATION.GET_DANH_SACH_TAI_XE_LIST),
//       mergeMap((action) => {
//          const api = async () => {
//             let data = {}

//             // Lấy danh sách tài xế
//             const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_ALL, action.payload)

//             data = {
//                danhSachDanhMuc: danhSachDanhMuc.data
//                // danhSachTinhThanh: danhSachTinhThanh.data,
//                // danhSachTaiXe: danhSachTaiXe.data
//             }

//             // Lấy chi tiết tài xế đầu tiên trong danh sách
//             if (danhSachDanhMuc.data.data.length > 0) {
//                const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_BY_ID, {
//                   driver_id: danhSachDanhMuc.data.data[0].id
//                })
//                data.chiTietDanhMuc = chiTietDanhMuc.data.data
//             } else {
//                data.chiTietDanhMuc = {}
//             }

//             const arrayAction = []
//             arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
//             return arrayAction
//          }
//          return concat(
//             from(api()).pipe(
//                mergeMap((res) => concat(from(res))),
//                catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
//             )
//          )
//       })
//    )

const LayDanhSachTaiXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DRIVERS_TRANSPORTATION.GET_DANH_SACH_TAI_XE_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}

            // Lấy danh sách tài xế
            const danhSachTaiXe = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_ALL, action.payload)

            data = {
               danhSachTaiXe: danhSachTaiXe.data
            }

            // Lấy chi tiết tài xế đầu tiên trong danh sách
            if (danhSachTaiXe.data.data.length > 0) {
               const chiTietTaiXe = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_BY_ID, {
                  driver_id: danhSachTaiXe.data.data[0].id
               })
               data.chiTietTaiXe = chiTietTaiXe.data.data
            } else {
               data.chiTietTaiXe = {}
            }

            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API lấy chi tiết tài xế đang select
const LayChiTietTaiXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DRIVERS_TRANSPORTATION.GET_DANH_SACH_TAI_XE_LIST_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            const chiTietTaiXe = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_BY_ID, { ...action.payload })
            console.log("api -> chiTietTaiXe", chiTietTaiXe)

            let data = {}
            data = { chiTietTaiXe: chiTietTaiXe.data.data }

            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
            console.log("api -> arrayAction", arrayAction)
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

// API thêm mới Tài Xế
const ThemMoiTaiXe = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.DRIVERS_TRANSPORTATION.POST_DANH_SACH_TAI_XE_LIST),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []

            // Kiểm tra format date, định dạng lại cho đúng trong payload của healthy_monitoring
            // if (action.payload.extend_data.healthy_mornitoring.date)
            //    action.payload.extend_data.healthy_mornitoring.date = CONSTANTS.FUNCTION.COMMON.formatDate(
            //       action.payload.extend_data.healthy_mornitoring.date,
            //       "DD/MM/YYYY"
            //    )

            const phuLucThem = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DRIVERS_TRANSPORTATION.POST_DANH_SACH_TAI_XE_LIST, action.payload)

            phuLucThem.data.status
               ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, phuLucThem.data.status))
               : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, phuLucThem.data.mess))

            // Load thông tin extend_data của tài xế
            const thongTinChiTietTaiXe = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.DRIVERS_TRANSPORTATION.GET_BY_ID}?driver_id=${action.payload.driver_id}`
            )

            // arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DRIVERS_TRANSPORTATION.GET_BY_ID, thongTinTaiXe.data))

            // arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, thongTinChiTietTaiXe.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

const GetListPhuTung = (action$, state$) => action$.pipe(
   ofType(CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG),
   mergeMap((action) => {
      const api = async () => {
         let data = {}
         let chiTiet = {}

         const danhSachDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG, action.payload)

         if (danhSachDanhMuc.data.data.length > 0) {
            chiTiet = danhSachDanhMuc.data.data[0]
         }
         const danhSachLoaiPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_TYPE_PHU_TUNG)
         

         data = {
            danhSachDanhMuc: danhSachDanhMuc.data,
            danhSachLoaiPhuTung: danhSachLoaiPhuTung.data,
            chiTietDanhMuc: chiTiet
         }
         
         const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
      }
      return concat(
         from(api()).pipe(
            mergeMap((res) => concat(from(res))),
            catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
         )
      )
   })
)

const ThemMoiPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.POST_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			const postPhutung = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.PHU_TUNG.POST_PHU_TUNG, action.payload)	

			postPhutung.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, postPhutung.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, postPhutung.data.mess))
			
			// Reload new list
			// const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG)		
         
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG))
			
         return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const CapNhatPhuTung = (action$, state$) => action$.pipe(
	ofType(CONSTANTS.ACTION.PHU_TUNG.PUT_PHU_TUNG),
	mergeMap((action) => {
		const api = async () => {
			const arrayAction = []
			
			const updatePhutung = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.PHU_TUNG.PUT_PHU_TUNG, action.payload)			
			updatePhutung.data.status
				? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updatePhutung.data.status))
				: arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updatePhutung.data.mess))
            
			// Reload new list
			arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG))


			// const danhSachPhuTung = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG)			
			// // arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data.data))
			// arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.PHU_TUNG.SET_PHU_TUNG, danhSachPhuTung.data))
			
			return arrayAction
		}
		return concat(
			from(api()).pipe(
				mergeMap((res) => concat(from(res))),
				catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
			)
		)
	})
)

const LayChiTietPhuTung = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.PHU_TUNG.GET_LIST_PHU_TUNG_BY_ID),
      mergeMap((action) => {
         const api = async () => {
            let data = {}
            const chiTietDanhMuc = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.PHU_TUNG.GET_LIST_PHU_TUNG_BY_ID, { ...action.payload }) //action.payload  { ...action.payload, type: 4 }
            data = { chiTietDanhMuc: chiTietDanhMuc.data.data[0] }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_MENU_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
// // API cập nhật đăng ký xe
// const UpdateDangKyXe = (action$, state$) =>
//    action$.pipe(
//       ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.PUT_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST),
//       mergeMap((action) => {
//          const api = async () => {
//             const arrayAction = []
//             const updateTodoList = await CONSTANTS.FUNCTION.AXIOS.POST(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.PUT, { ...action.payload, type: 3 })
//             // Reload lại state để cập nhật đăng kiểm vừa cập nhật
//             arrayAction.push(
//                CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST, {
//                   keyword: "",
//                   page: 1
//                })
//             )
//             updateTodoList.data.status
//                ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, updateTodoList.data.status))
//                : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, updateTodoList.data.mess))
//             return arrayAction
//          }
//          return concat(
//             from(api()).pipe(
//                mergeMap((res) => concat(from(res))),
//                catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
//             )
//          )
//       })
//    )
// // API xóa đăng ký xe
// const DeleteDangKyXe = (action$, state$) =>
//    action$.pipe(
//       ofType(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.DELETE_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST),
//       mergeMap((action) => {
//          const api = async () => {
//             const arrayAction = []
//             const deleteTodoList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.DELETE, { ...action.payload, type: 3 })
//             // Reload lại state để cập nhật đăng kiểm vừa xoá
//             arrayAction.push(
//                CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE.GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST, {
//                   keyword: "",
//                   page: 1
//                })
//             )
//             deleteTodoList.data.status
//                ? arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.STATUS, deleteTodoList.data.status))
//                : arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, deleteTodoList.data.mess))

//             return arrayAction
//          }
//          return concat(
//             from(api()).pipe(
//                mergeMap((res) => concat(from(res))),
//                catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
//             )
//          )
//       })
//    )
// FORM LIST : hình thức công việc
const getAllFormList = (action$, state$) =>
   action$.pipe(
      ofType(CONSTANTS.ACTION.FORM_LIST.GET_FORM_LIST),
      mergeMap((action) => {
         const api = async () => {
            let data = {}
            // Lấy danh sách việc
            // const formList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.FORM_LIST.GET_DS_V, action.payload)
            const formList = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.FORM_LIST.GET_ALL, action.payload)
            data = { formList: formList.data }

            // BUG:  Mở đoạn code bên dưới khi làm các form resfull api cho hình thức
            // if (formList.data.data.length > 0) {
            //   // Lấy chi tiết việc đầu tiên trong danh sách
            //   const formListDetail = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TODO_LIST.GET_BY_ID, { id: danhSachDanhMuc.data.data[0].id })
            //   data.formListDetail = formListDetail.data.data
            // } else {
            //   data.formListDetail = {}
            // }
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MENU.UPDATE_FORM_LIST, data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )

export default {
   getAllTodoList,
   getTodoDetail,
   addTodo,
   updateTodo,
   deleteTodo,
   getAllFormList,
   LayDanhMucBaoDuong,
   LayChiTietDanhMucBaoDuong,
   AddBaoDuong,
   UpdateBaoDuong,
   DeleteBaoDuong,
   LayDanhSachTrungTamDangKiem,
   LayChiTietDanhSachTrungTamDangKiem,
   AddTrungTamDangKiem,
   UpdateTrungTamDangKiem,
   DeleteTrungTamDangKiem,
   LayDanhSachNhaCungCapBaoHiem,
   LayChiTietBaoHiem,
   AddBaoHiem,
   UpdateBaoHiem,
   DeleteBaoHiem,
   LayDanhSachNhaCungCapPhuHieu,
   LayChiTietPhuHieu,
   AddPhuHieu,
   UpdatePhuHieu,
   DeletePhuHieu,
   LayDanhSachNhaCungCapDangKyXe,
   LayChiTietDangKyXe,
   AddDangKyXe,
   UpdateDangKyXe,
   DeleteDangKyXe,
   LayDanhSachTaiXe,
   LayChiTietTaiXe,
   ThemMoiTaiXe,
   GetListPhuTung,
   ThemMoiPhuTung,
   CapNhatPhuTung,
   LayChiTietPhuTung

}
